// CurrencyTextField.jsx
import * as React from 'react';
import TextField from '@mui/material/TextField';
import { NumericFormat } from 'react-number-format';

// Bridges NumericFormat -> MUI TextField (controlled)
const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(props, ref) {
  const { onChange, name, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      thousandSeparator
      valueIsNumericString
      prefix="$"
      decimalScale={2}
      fixedDecimalScale={false} // let the user delete decimal digits freely
      allowEmptyFormatting
      allowNegative={false}
      // Send a numeric value back to TextField onChange
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.floatValue ?? '' // '' when cleared
          }
        });
      }}
    />
  );
});

export default function CurrencyTextField({
  label = 'Amount',
  value,
  onChange,
  required,
  error,
  helperText,
  fullWidth = true,
  name = 'currency',
  ...rest
}) {
  return (
    <TextField
      {...rest}
      label={label}
      required={required}
      fullWidth={fullWidth}
      value={value ?? ''}          // keep controlled
      name={name}
      onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
      error={Boolean(error)}
      helperText={helperText}
      InputProps={{
        inputComponent: NumericFormatCustom
      }}
    />
  );
}
